export enum TabsOrientation {
  horizontal = 'horizontal',
  vertical = 'vertical',
}
